import { render, staticRenderFns } from "./dossiers-config.vue?vue&type=template&id=7565fb3c&scoped=true"
import script from "./dossiers-config.vue?vue&type=script&lang=js"
export * from "./dossiers-config.vue?vue&type=script&lang=js"
import style0 from "./dossiers-config.vue?vue&type=style&index=0&id=7565fb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7565fb3c",
  null
  
)

export default component.exports